import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';

export default class NewsletterCTA extends Component {
  render () {
    return (
      <section className={`${this.props.css['newsletter-cta']} ${this.props.css.bottom}`}>
        <div className={this.props.css['panel-content']}>
          <h1>
            <FormattedMessage
              id="ui.branding.heading.NEWSLETTER_CTA_SIGN_UP"
              defaultMessage="Pledge Your Allegiance"
              description="Heading appearing every page of the Dawn of War site encouraging people to sign up for the newsletter." />
          </h1>
          <h5>
            <FormattedMessage
              id="ui.brancing.copy.NEWSLETTER_CTA_SIGN_UP"
              defaultMessage="The Loyal Are Rewarded"
              description="Copy appearing on every page of the Dawn of War site encouraging people to sign up for the newsletter." />
          </h5>
          <p>
            <a target="_blank" href={this.props.links.sso_signup} className={`${this.props.css.btn} ${['btn-secondary']}`}>
              <FormattedMessage
                id="ui.label.button.NEWSLETTER_CTA_SIGN_UP"
                defaultMessage="Sign Up Now"
                description="Button appearing on every page of the Dawn of War site linking to the newsletter sign up." />
            </a>
          </p>
        </div>
      </section>);
  }
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/newsletter-cta.jsx